import { Injectable } from '@angular/core';

/*
  Generated class for the ResolutionsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ResolutionsProvider {
  resolutions = null;
  constructor() {
    // console.log('Hello ResolutionsProvider Provider');
  }

  getResolutions(){
    if(this.resolutions == null){
      this.resolutions = {};
      this.initResolutions();
    }
    // console.log("getResolutions",this.resolutions);
    return this.resolutions;
  }

  initResolutions(){
    this.resolutions.push({
      index:0,
      title:"Normal",
      name:"normal",
      width: 1024,
      height: 1024,
      margin: {
        top:0,
        right:0,
        bottom:0,
        left:0,
      }
    });
    this.resolutions.push({
      index:1,
      title:"Portrait",
      name:"portrait",
      width: 512,
      height: 1024,
      margin: {
        top:0.25,
        right:0,
        bottom:0.25,
        left:0,
      }
    });
    this.resolutions.push({
      index:2,
      title:"Paysage",
      name:"landscape",
      width: 1024,
      height: 512,
      margin: {
        top:0,
        right:0.25,
        bottom:0,
        left:0.25,
      }
    });

  }

}



// WEBPACK FOOTER //
// ./src/providers/resolutions/resolutions.ts